/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Rails_AriaInputs */

const en_directory_promotion_rails_aria = /** @type {(inputs: Directory_Promotion_Rails_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured products`)
};

const zh_directory_promotion_rails_aria = /** @type {(inputs: Directory_Promotion_Rails_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选产品`)
};

/**
* | output |
* | --- |
* | "Featured products" |
*
* @param {Directory_Promotion_Rails_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_rails_aria = /** @type {((inputs?: Directory_Promotion_Rails_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Rails_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_rails_aria(inputs)
	return zh_directory_promotion_rails_aria(inputs)
});
export { directory_promotion_rails_aria as "directory.promotion.rails_aria" }